export const environment = {
    production: false,
    // DEV Database - Update these with your development Supabase credentials
    apiUrl: 'https://rridoiolkbjrhtolscxi.supabase.co',
    apiKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJyaWRvaW9sa2Jqcmh0b2xzY3hpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMyNDY5OTksImV4cCI6MjA4ODgyMjk5OX0.VuMAlb7wBEEo0zF3uwyK27z3HIStL020itbL6iMGRdM'
};

// export const environment = {
//   production: false,
//   // DEV Database - Update these with your development Supabase credentials
//   apiUrl: 'https://djjhsefzwlztiaehekyr.supabase.co',
//   apiKey: 'sb_publishable_22PUCrlj7omn86j-xzzVwg_7xe-ulLI',
// };
